import { loadConfig } from '@api/api';
import axios, { AxiosResponse } from 'axios';

const getLicenseApi = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/version/license`;
};

const formatRemainDate = (raw: string) => {
  const parts = raw.split(':');
  const text = parts.length > 1 ? parts.slice(1).join(':') : raw;

  const daysMatch = text.match(/(\d+)\s*d/i);
  const hoursMatch = text.match(/(\d+)\s*h/i);
  const minutesMatch = text.match(/(\d+)\s*m/i);

  const totalDays = daysMatch ? Number(daysMatch[1]) : 0;
  const hours = hoursMatch ? Number(hoursMatch[1]) : 0;
  const minutes = minutesMatch ? Number(minutesMatch[1]) : 0;

  const years = Math.floor(totalDays / 365);
  const remainingDays = totalDays % 365;
  const months = Math.floor(remainingDays / 30);

  return `- License Remaining -\n${years} Years ${months} Months ${hours} Hours ${minutes} Minutes`;
};

export async function getLicenseInfo() {
  const url = await getLicenseApi();

  const res: AxiosResponse = await axios({
    method: 'get',
    url: url,
    headers: {
      Accept: '*/*',
    },
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return res;
    });

  if (res.status === 200 || res.status === 201) {
    const remainDate = String(res.data['remainDate'] ?? '');
    return [true, formatRemainDate(remainDate)];
  } else {
    return [false, ''];
  }
}
